export function groupByDomain<T extends { name: string; domain?: string }>(
  items: T[],
) {
  const byDomain: Record<string, T[]> = {};
  items.forEach(i => {
    const domain = i.domain || 'Others';
    if (domain in byDomain) byDomain[domain].push(i);
    else byDomain[domain] = [i];
  });

  return byDomain;
}
